import { BatchDto } from "@juicy/models/dto";
import { useNavigation } from "@react-navigation/native";
import { Button, Icon, Input, Text } from "@ui-kitten/components";
import moment from "moment";
import React from "react";
import { View } from "react-native";
import { SectionDataList } from "../common/dataList/SectionDataList";
import { DataListType, useDataList } from "../common/dataList/useDataList";
import { ScreenLayout } from "../common/layout/ScreenLayout";
import { BatchNavigation } from "../navigation";
import { BatchListItem } from "./BatchListItem";

const renderSectionHeader = (info: { section: { title: any; data: any[] } }) => {
    return (
        <View
            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                backgroundColor: "rgb(51, 102, 255)",
                padding: 5,
                paddingRight: 15,
                borderRadius: 4,
                marginBottom: 5,
            }}
        >
            <Text style={{ color: "white" }} category="s2">
                {info.section.title}
            </Text>
            {info.section.data && info.section.data.length > 0 && (
                <Text style={{ color: "white" }} category="s2">
                    {moment(info.section.data[0].createdAt).fromNow()}
                </Text>
            )}
        </View>
    );
};

export const BatchListScreen: React.FC = () => {
    const { data, isLoading, refresh, loadMore, isLoadingMore, setFilter, filter } = useDataList(DataListType.Batch);
    const sectionedData: Array<{ title: string; data: any[] }> = [];

    for (const item of data.list as BatchDto[]) {
        const date = moment(new Date(item.createdAt)).format("MMM D YYYY");
        const index = sectionedData.findIndex((i) => i.title === date);
        if (index === -1) {
            sectionedData.push({ title: date, data: [item] });
        } else {
            sectionedData[index].data.push(item);
        }
    }

    const navigation = useNavigation<BatchNavigation>();

    const RenderBatchListItem = ({ item }: { item: any }) => (
        <View style={{ paddingVertical: 4 }}>
            <BatchListItem batch={item} ratingExpanded={false} />
        </View>
    );

    return (
        <ScreenLayout scroll={false} title="Batches">
            <View style={{ flex: 1, padding: 8 }}>
                <View
                    style={{
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        height: 56,
                        alignItems: "center",
                    }}
                >
                    <Text category="h4" style={{ fontWeight: "600" }}>
                        BATCHES
                    </Text>
                    <Button
                        onPress={refresh}
                        appearance="ghost"
                        status="basic"
                        accessoryLeft={(props) => <Icon {...props} name="refresh" />}
                    />
                </View>
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        height: 50,
                    }}
                >
                    <Input
                        placeholder="Search batches"
                        onChangeText={(text) => {
                            setFilter((current) => ({
                                ...current,
                                search: text,
                            }));
                        }}
                        value={filter.search}
                        style={{ flex: 1 }}
                    />
                    <Button
                        size="small"
                        style={{ width: 32, marginLeft: 16 }}
                        accessoryLeft={(props) => <Icon {...props} name="plus" />}
                        onPress={() => navigation.navigate("BatchCreateScreen", {})}
                    />
                </View>
                <SectionDataList
                    sections={sectionedData}
                    renderSectionHeader={renderSectionHeader}
                    data={data}
                    renderItem={RenderBatchListItem}
                    isLoading={isLoading}
                    isLoadingMore={isLoadingMore}
                    loadMore={loadMore}
                    refresh={refresh}
                />
            </View>
        </ScreenLayout>
    );
};
